{
  "id": "campaign-034",
  "name": "Shaggy Playground",
  "seed": "campaign:34",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,_,,,,,,,",
    ",b,,_...,,b,",
    "*,,,_...,,,*",
    "*b,._...,,b*",
    "*,,._...,,,*",
    "*z,._.....,*",
    "*zb,_..#.b.*",
    ",z,,_,...,,,",
    ".z.._,,,,,,,",
    ".z.._,,,,,,,",
    ".z.._,,,,,,,",
    ".zww_,,,,,,,",
    ".zww_,,,,,,,",
    "zzww_,,,,,.x",
    ",,,,_,,,,...",
    ",,,,_sss,x..",
    "..,,,sss,...",
    "S...,,,,,,.."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 7,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 5,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 17
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 16
    }
  ],
  "generatorVersion": 3,
  "level": 34,
  "biome": "park",
  "par": {
    "reel": 15524,
    "push": 9360,
    "selfPropelled": 8712,
    "tractor": 5080,
    "zeroTurn": 5977,
    "fairway": 4448
  },
  "routeTries": {
    "par": {
      "reel": 9,
      "push": 8,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 17,
      "fairway": 18
    }
  }
}
